import SentiLinkIcon from "src/assets/SentiLinkIcon.svg?react";
import {
  getDefaultSentiLinkCustomScoreProducts,
  getDefaultSentiLinkFacets,
  getDefaultSentiLinkIDComplete,
  getDefaultSentiLinkIdentityTheftScore,
  getDefaultSentiLinkInsightsReport,
  getDefaultSentiLinkSyntheticFraudScore,
} from "src/connections/connectionConfigs/sentiLink/sentiLinkResources";
import { SentiLinkTemplate } from "src/connections/connectionConfigs/sentiLink/sentiLinkTemplate";
import { ConnectionConfig } from "src/connections/connectionConfigs/types";

export const SENTILINK_CONFIG: ConnectionConfig<"sentilink"> = {
  icon: SentiLinkIcon,
  description: "Your partner in solving emerging threats",
  template: SentiLinkTemplate,
  name: "US | SentiLink",
  resources: {
    sentilink_synthetic_fraud_score: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/sentilink#synthetic-fraud-score",
      integrationResource: getDefaultSentiLinkSyntheticFraudScore,
    },
    sentilink_identity_theft_score: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/sentilink#identity-theft-score",
      integrationResource: getDefaultSentiLinkIdentityTheftScore,
    },
    sentilink_custom_score_products: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/sentilink#custom-score-products",
      integrationResource: getDefaultSentiLinkCustomScoreProducts,
    },
    sentilink_facets: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/sentilink#facets",
      integrationResource: getDefaultSentiLinkFacets,
    },
    sentilink_id_complete: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/sentilink#sentilink-id-complete",
      integrationResource: getDefaultSentiLinkIDComplete,
    },
    sentilink_insights_report: {
      externalLink:
        "https://docs.taktile.com/integrations/third-party-connections/kyb-kyc-and-fraud/sentilink#sentilink-insights",
      integrationResource: getDefaultSentiLinkInsightsReport,
    },
  },
};
